var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"video"},[_c('div',{staticClass:"video-placeholder"},[_c('span',{staticClass:"video-length"},[_vm._v(_vm._s(_vm.videoLengthString)+" Min")]),_c('ImageView',{attrs:{"source":_vm.imgSrc}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }